import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>Built by Robert Anderson &middot; <a href="https://github.com/robaandersonjr-ux/anime-search-react" target="_blank" rel="noopener noreferrer">View on GitHub</a> &middot; Powered by OMDB</p>
    </footer>
  );
}

export default Footer;